import { render, staticRenderFns } from "./surPlusTemp.vue?vue&type=template&id=0da8283f&scoped=true&"
import script from "./surPlusTemp.vue?vue&type=script&lang=js&"
export * from "./surPlusTemp.vue?vue&type=script&lang=js&"
import style0 from "./surPlusTemp.vue?vue&type=style&index=0&id=0da8283f&prod&lang=less&scoped=true&"
import style1 from "./surPlusTemp.vue?vue&type=style&index=1&id=0da8283f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8283f",
  null
  
)

export default component.exports